import React from "react";
import { Box, Typography } from "@mui/material";
import { useIntl } from "react-intl";

export default function OperationProgramListPage() {
  const intl = useIntl();
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        {intl.formatMessage({ id: "menu.programs" })}
      </Typography>
      {/* TODO: プログラム一覧の実装 */}
    </Box>
  );
}
